import React from 'react'
import Image from 'react-bootstrap/Image';
import image from '../assets/robot.png'
import TabButton from './TabButton';
import { useState } from 'react'

const About = ({ children }) => {
  const [curTab, setCurTab] = useState("skills")
  let count = 0

  const tabs = [
    {
      id: "skills",
      content: ["Python", "Java", "C", "ReactJS", "NodeJS", "HTML"],
    },
    {
      id: "education",
      content: ["Carleton University", "B.C.S. Honours", "2022 - Present"]
    }
  ]

  const handleSelect = (tab) => {
    setCurTab(tab)
  }

  return (
    <div className="text-white pt-16">
      <div className="flex-col flex lg:grid lg:grid-cols-2 lg:grid-rows-4 lg:p-20">
        <div className="flex justify-center lg:justify-start">
          <Image src={image} className="w-64 h-64 md:w-2/5 md:h-auto lg:w-4/5 lg:h-auto" thumbnail />
        </div>
        <div className="md:flex md:flex-col md:h-full">
          <h2 className="justify-center flex mt-10 text-3xl lg:mt-0 lg:text-xl lg:justify-start md:text-3xl xl:text-3xl">About Me</h2>
          <p className="sm:ml-28 sm:mr-28 pt-4 lg:mr-24 text-justify text-base ml-12 mr-12 flex justify-center lg:text-base lg:ml-0 lg:justify-start xl:mr-44 md:text-xl xl:text-lg">
            Hello! My name is Zhiyao and you can also call me Ian. I am currently a second year undergraduate student majoring in computer science, and I am dedicated to seizing every opportunities for learning and skill development. 
            I am very passionate about artificial intelligence and machine learning, with the goal of becoming an expert in these fields so that I can use my knowledge and make a positive impact on society. During my free time, I enjoy reading
            books of all kinds, especially on science-fiction and physics. I also like to swim and workout at the gym as a way to boost my physical wellness. 
          </p>
          <div className="mt-20 flex flex-row justify-center lg:justify-start lg:mt-8">
            <TabButton active={curTab === 'skills'} selectTab={handleSelect} name='Skills' />
            <TabButton active={curTab === 'education'} selectTab={handleSelect} name='Education' />
          </div>
          <div className="mt-4 flex flex-col sm:ml-28 sm:mr-28 lg:mr-24 ml-12 h-48 mr-12 text-justify justify-center md:text-base lg:text-base xl:text-lg lg:mt-8 lg:justify-start lg:ml-0 xl:mr-44 lg:h-0">
            {tabs.find((t) => t.id === curTab).content.map(c => {
              count += 1
              return <li key={count} className="flex md:text-xl xl:text-lg lg:text-base text-base justify-center lg:justify-start mb-1">{c}</li>
            })}
          </div>
        </div>
        <div className="justify-center flex col-span-2 lg:mt-16 xl:mt-0">
          {children}
        </div>
      </div>
    </div>
  )
}

export default About